module.exports = __webpack_public_path__ + "img/ico_video_play@2x.63609844.png";